export const advertisingModalTrackers = {
  actions: {
    modalAppeared: 'Modal de Propaganda: Apareceu na tela',
    clicked: 'Modal de Propaganda: Clicou na propaganda',
    closeModal: 'Modal de Propaganda: Clicou em sair do modal',
  },
}
